import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas, RIGHT_RAIL_GAP } from '../../styles';

export const SIZES = {
    player: {
        large: 64,
    },
    stats: {
        extraLarge: 108,
        // TODO large should be removed once we're returning the last 5 games (It'll revert to medium styling)
        large: 80,
        medium: 72,
        small: 44,
    },
};

const PADDING = 24;
// 16px of padding on left/right of the page
const PAGE_SPACING_SMALL = 32;
const PAGE_SPACING_LARGE = PAGE_SPACING_SMALL + RIGHT_RAIL_GAP;
const COMPARE_WIDTHS_MEDIUM =
    1 + (PADDING + SIZES.player.large + SIZES.stats.medium) * 2 + BaseStyle.GAP_SIZES.large * 6;
const COMPARE_WIDTHS_LARGE = 1 + (PADDING + SIZES.player.large + SIZES.stats.large) * 2 + BaseStyle.GAP_SIZES.large * 6;
const COMPARE_WIDTHS_EXTRA_LARGE =
    1 + (PADDING + SIZES.player.large + SIZES.stats.extraLarge) * 2 + BaseStyle.GAP_SIZES.large * 6;

export const PlayersToWatchContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.playersToWatch};

    ${BaseStyle.Mixins.screenSizes.medium} {
        border: solid 1px ${({ theme }) => theme.Surface.border};
        border-radius: 4px;
        padding: ${PADDING}px;
    }
`;

export const DetailContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.semiLarge}
    }
`;

export const PlayerContainer = styled.a<{ $isRightAligned: boolean }>`
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: ${({ $isRightAligned }) => ($isRightAligned ? 'end' : 'start')};
    height: 44px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-left: ${({ $isRightAligned }) => ($isRightAligned ? '0' : '12px')};
        margin-right: ${({ $isRightAligned }) => ($isRightAligned ? '12px' : '0')};
        height: 52px;
    }
`;

export const HeadshotContainer = styled.a<{ $isRightAligned: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: ${({ $isRightAligned }) => ($isRightAligned ? 'end' : 'start')};

    .headshot-container {
        top: -4px;
    }
`;

const PlayerName = styled.div`
    overflow: hidden;
    padding-bottom: 4px;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${BaseStyle.Mixins.screenSizes.medium} {
        max-width: calc((100vw - ${PAGE_SPACING_SMALL}px - ${COMPARE_WIDTHS_MEDIUM}px) / 2);
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        max-width: min(170px, calc((((100vw - ${PAGE_SPACING_LARGE}px) * (2 / 3)) - ${COMPARE_WIDTHS_LARGE}px) / 2));
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        max-width: min(
            170px,
            calc((((100vw - ${PAGE_SPACING_LARGE}px) * (2 / 3)) - ${COMPARE_WIDTHS_EXTRA_LARGE}px) / 2)
        );
    }
`;

export const PlayerNameContainer = styled.div<{ $isRightAligned: boolean }>`
    display: flex;
    flex-direction: column;
    height: 32px;
    text-align: ${({ $isRightAligned }) => ($isRightAligned ? 'end' : 'start')};

    ${BaseStyle.Mixins.screenSizes.large} {
        height: 38px;
    }
`;

export const FirstName = styled(PlayerName)`
    ${BaseStyle.Mixins.fontStyles.desktop.body3}
    max-height: 18px;
`;

export const LastName = styled(PlayerName)`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['18b']}
    }
`;

export const SweaterAndPosition = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.Text.secondary};

    .team-display-container {
        display: inline-block;

        img {
            height: 16px;
            width: 24px;
        }
    }
`;
